import { render, staticRenderFns } from "./disSetting.vue?vue&type=template&id=3ccfedf6&scoped=true"
import script from "./disSetting.vue?vue&type=script&lang=js"
export * from "./disSetting.vue?vue&type=script&lang=js"
import style0 from "./disSetting.vue?vue&type=style&index=0&id=3ccfedf6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccfedf6",
  null
  
)

export default component.exports